import { lazyWithPreload as lazy } from 'react-lazy-with-preload';

const Quote = {
  Template: lazy(
    () => import('components/direct-sales/quote/components/QuoteTemplate')
  ),
  Skyline: lazy(
    () => import('components/direct-sales/quote/components/QuoteSkyline')
  ),
  Content: lazy(
    () => import('components/direct-sales/quote/components/Tariffs')
  ),
  LeftSidebar: lazy(
    () => import('components/direct-sales/quote/components/QuoteSidebarLeft')
  ),
  Header: lazy(
    () => import('components/direct-sales/quote/components/QuoteHeader')
  ),
  Footer: lazy(
    () => import('components/direct-sales/quote/components/QuoteFooter')
  )
};

export default Quote;
